import { getPartsUrl } from 'js/utils/url.util';
export * from 'js/utils/url.util';

export const getPathWithParamsAndHash = (url) => {
    const [, , , formattedPath, params = '', hash] = getPartsUrl(url);

    return [formattedPath, params, hash].filter(Boolean).join('');
};

export const kambiNavigate = (url) => {
    const hash = url?.split?.('#')?.[1];

    if (!hash) {
        return;
    }

    location.hash = hash;
};
